(function ($, Cobalt, undefined) {
    var _imageManagerModal;
    var _imageManager;
    var _sortOrder;
    var _thumbnailSize;
    var _thumbnailWidth;
    var _thumbnailHeight;
    var _entityTypeID;
    var _entityID;
    var _listingFilterForm;
    var _bulkModerationForm;
    var _loadingMask;

    // View States
    var _categoryViewState;
    var _postTypeViewState;
    var _sizeViewState;
    var _sortViewState;
    var _hasLoaded = false;
    var _isLoading = false;
    var _onLoadComplete;
    var _viewControls;
    var _viewLinks;
    var _sortControls;
    var _sortLinks;
    var _searchFilter;
    var _currentParentID;
    var _insertCallback;
    var _defaultImageWidth;
    var _allowedContentTypes;
    var _dragDropSupported = false;
    var _modeViewState;
    var _featuredViewState;
    var _uploadMode = 0; // 0 = None, 1 = Image, 2 = Audio, 3 = File

    Cobalt.ImageManager = {
        uploadMode: function () {
            return _uploadMode;
        },
        showInstructions: function () {

            // Ensure the instructions are not shown when the modal is invisible.
            if (!_imageManager.is(":visible")) {
                return;
            }

            if (_dragDropSupported && _uploadMode != 0 && !$(".instructions").is(":visible") && $.cookie("Cobalt.ImageManager.instructions") == null) {
                setTimeout(function () {
                    $(".instructions").fadeIn("slow");

                    setTimeout(function () {
                        if (!$(".instructions").is(":visible")) {
                            return;
                        }
                        $(".instructions").fadeOut("slow");
                    }, 5000);
                }, 2000);
            } else if (_modeViewState.value == "template-select") {

                setTimeout(function () {
                    $(".template-select-instructions").fadeIn("slow");
                }, 2000);
            }
        },
        hideModal: function () {
            _imageManagerModal.hide();
            $("body").css("overflow", "auto");
        },
        showModal: function (target, insertCallback, mode, defaultCategoryID, featuredOnly) {

            _insertCallback = insertCallback;
            if (mode !== undefined) {
                if (_modeViewState === undefined) {
                    _modeViewState = Cobalt.ViewStateManager.getViewState("m", mode);
                } else {
                    _modeViewState.setValue(mode);
                }
            }
            if (featuredOnly !== undefined) {
                if (_featuredViewState === undefined) {
                    _featuredViewState = Cobalt.ViewStateManager.getViewState("f", featuredOnly);
                } else {
                    _featuredViewState.setValue(featuredOnly);
                }
            }
            if (defaultCategoryID !== undefined) {
                if (_categoryViewState === undefined) {
                    _categoryViewState = Cobalt.ViewStateManager.getViewState("c", defaultCategoryID);
                } else {
                    _categoryViewState.setValue(defaultCategoryID);
                }
            }


            if (mode !== undefined || defaultCategoryID !== undefined) {
                $(window).trigger("hashchange");
                setTimeout(function () {

                    _imageManagerModal.show();
                    $("body").css("overflow", "hidden");

                    //_imageManagerModal.center({ sizeToWindow: true, paddingWidth: 0 });
                    //_imageManagerModal.fadeIn();
                    Cobalt.ImageManager.showInstructions();
                }, 200);
            }
            else {
                _imageManagerModal.show();
                $("body").css("overflow", "hidden");
                Cobalt.ImageManager.showInstructions();
            }

            switch (mode) {
                case "image":
                    _imageManager.find(".insert-image-options").show();
                    break;
            }

        },
        setPostType: function (postType) {
            if (_postTypeViewState === undefined) {
                _postTypeViewState = Cobalt.ViewStateManager.getViewState("pt", postType);
            } else {
                _postTypeViewState.setValue(postType);
            }
        },
        dependentScripts: function () {
            return [
                { dependency: Cobalt.User, name: "Cobalt.User" },
                { dependency: Cobalt.UI, name: "Cobalt.UI" },
                { dependency: Cobalt.Listing, name: "Cobalt.Listing" },
                { dependency: Cobalt.Markup, name: "Cobalt.Markup" },
                { dependency: Cobalt.BulkModeration, name: "Cobalt.BulkModeration" }
            ];
        },
        initialize: function () {

            Cobalt.ViewStateManager.createBrowserHistory = true;

            _dragDropSupported = (typeof FileReader != "undefined" && FileReader != null);
            _imageManager = $("#image-manager");
            _sortOrder = 1;
            _thumbnailSize = _imageManager.attr("data-thumbnail-size-value");
            _thumbnailWidth = _imageManager.attr("data-thumbnail-width");
            _thumbnailHeight = _imageManager.attr("data-thumbnail-height");
            _entityTypeID = _imageManager.attr("data-entity-type-id");
            _entityID = _imageManager.attr("data-entity-id");
            _defaultImageWidth = _imageManager.attr("data-default-image-width");

            _categoryViewState = Cobalt.ViewStateManager.getViewState("c", _entityID);

            _postTypeViewState = Cobalt.ViewStateManager.getViewState("pt", "");

            _sizeViewState = Cobalt.ViewStateManager.getViewState("v", 2);

            _sortViewState = Cobalt.ViewStateManager.getViewState("s", 1);

            _modeViewState = Cobalt.ViewStateManager.getViewState("m", "");

            _featuredViewState = Cobalt.ViewStateManager.getViewState("f", false);

            _bulkModerationForm = _imageManager.find("div.bulk-moderation > form");

            var $listing = _imageManager.find("ul.listing");
            _loadingMask = _imageManager.find("div.listing-container > div.loading");
            var $pagination = _imageManager.find(".j-tablesorter-pager");

            _listingFilterForm = _imageManager.find("form.listing-filters");
            var $formUrl = _imageManager.attr("data-listing-url");
            var $uploadForm = _imageManager.find("form.image-manager-form");
            var $autoSearchTimeout = null;


            _searchFilter = _listingFilterForm.find("#filter-search");
            _searchFilter.watermark("Search by name");
            _searchFilter.attr("autocomplete", "off");
            _imageManagerModal = $("#image-manager-modal");





            var $searchFilterReset = $("<a class=\"reset\">x</a").click(function () {
                if (_searchFilter.val() != "") {
                    _searchFilter.val("");
                    Cobalt.ImageManager.refreshListing();
                }
            });


            // Prevent nav that could cause the user to lose data            
            var warningMessage = "You appear to have unsaved changes. Any unsaved changes will be lost if you close this window.";

            var submitClicked = false;
            var check = function (e) {
                if (submitClicked) {
                    return null;
                }
                submitClicked = false;
                var showWarning = false;
                var contentManagerForm = $(".content-manager-form");
                var hasChanges = false;
                contentManagerForm.find("input[type=text]").each(function () {
                    if (this.value != this.defaultValue) {
                        hasChanges = true;
                        return;
                    }
                });

                contentManagerForm.find('textarea').each(function () {
                    if (this.value != this.defaultValue) {
                        hasChanges = true;
                        return;
                    }
                });

                contentManagerForm.find('.select').each(function () {
                    if ($(this).is(":visible") && !this.options[this.selectedIndex].defaultSelected) {
                        hasChanges = true;
                        return;
                    }
                });

                if (hasChanges) {
                    return warningMessage;
                }

            };
            $(window).on("beforeunload", check);

            $('button[type=submit]').on('click', function () {
                submitClicked = true;
            });

            if (_imageManagerModal.length > 0) {
                _imageManagerModal.find("div.close").click(function () {
                    Cobalt.ImageManager.hideModal();
                    if (_modeViewState.value === "template-select") {
                        _postTypeViewState.setValue("");
                        _modeViewState.setValue("");
                        var url = "/cp/cms/folders" + self.location.hash;
                        self.location = url;
                    }
                });
                $('html,body').bind('keyup', function (e) {
                    if (e.keyCode == "27") {
                        Cobalt.ImageManager.hideModal();
                    }
                });
            }

            _imageManager.delegate("ul#categories > li > div.wrapper > img, ul#categories > li > div.wrapper > div.modifier-icon", "click", Cobalt.ImageManager.handleFolderClick);
            _imageManager.delegate("div.folder-breadcrumbs > ul > li", "click", Cobalt.ImageManager.handleFolderClick);
            _imageManager.delegate("li.post > div > a", "click", Cobalt.ImageManager.handlePostClick);
            _imageManager.delegate("li.category div.micro-controls > a.edit-button", "click", Cobalt.ImageManager.editFolder);
            _imageManager.delegate("li.video a.edit-button", "click", Cobalt.ImageManager.editVideo);
            _imageManager.delegate("li.audio a.edit-button", "click", Cobalt.ImageManager.editAudio);

            // Show Deleted
            if (Cobalt.User.Preferences.ShowDeletedContent) {
                _imageManager.find("input.show-deleted").attr("checked", "true");
            }
            _imageManager.find("input.show-deleted").change(function () {
                Cobalt.User.Preferences.ShowDeletedContent = _imageManager.find("input.show-deleted").is(":checked");
                Cobalt.User.savePreferences(true);
                Cobalt.ImageManager.refreshListing();
            });

            // Show Featured
            _imageManager.find("input.show-featured").change(function () {
                _featuredViewState.setValue($(this).is(":checked"));
                Cobalt.ImageManager.refreshListing();
            });

            // Delete/Undelete Buttons
            _imageManager.delegate("div.micro-controls > a.undelete-button,div.micro-controls > a.delete-button", "click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                var div = $(this).parents("div.wrapper");
                var mode = $(this).hasClass("delete-button") ? "delete" : "undelete";
                var that = $(this);
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    Cobalt.Forms.AjaxPostSubmit(that, token).done(function () {
                        if (mode == "undelete") {
                            div.removeClass("status-deleted");
                        }
                        else {
                            div.removeClass("status-draft");
                            div.removeClass("status-published");
                            div.addClass("status-deleted");
                        }
                    });
                });
            });

            // Social Button
            _imageManager.delegate("div.micro-controls > a.social-button", "click", function (e) {
                var href = $(this).attr("href");
                var div = $(this).parents("div.wrapper");
                div.addClass("social-loading");
                Cobalt.Utils.postWithToken(href, {}).done(function () {
                    div.removeClass("social-loading");
                });
                return false;
            });

            // Local Feature Button
            _imageManager.delegate("div.micro-controls > a.representative-button", "click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                var div = $(this).parents("div.wrapper");
                var allDivs = $(this).parents("ul#files, ul#videos, ul#posts").find("div.wrapper");
                var that = $(this);

                var that = $(this);
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    Cobalt.Forms.AjaxPostSubmit(that, token).done(function () {
                        div.toggleClass("representative");
                    });
                });
            });

            // Feature Button
            _imageManager.delegate("div.micro-controls > a.feature-button", "click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                if (href == null) {
                    return;
                }
                var div = $(this).parents("div.wrapper");
                var that = $(this);
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    Cobalt.Forms.AjaxPostSubmit(that, token).done(function () {
                        div.toggleClass("featured");
                    });
                });
            });

            // Index Button
            _imageManager.delegate("div.micro-controls > a.index-button", "click", function (e) {
                e.preventDefault();
                var href = $(this).attr("href");
                if (href == null) {
                    return;
                }
                var div = $(this).parents("div.wrapper");
                var that = $(this);
                Cobalt.Utils.getRequestVerificationToken().done(function (token) {
                    Cobalt.Forms.AjaxPostSubmit(that, token).done(function () {
                        div.toggleClass("index-entity");
                    });
                });
            });

            _imageManager.find("div.controls div.actions a.select-all > ul.sub-menu > li").click(function () {
                $("div.controls div.actions a.select-all > ul.sub-menu").hide();
                var inputSelector = "";
                var value = $(this).attr("data-value");
                switch (value) {
                    case "everything":
                    case "nothing":
                        inputSelector = "div.listing-container div.wrapper:not(.parent-category) div.micro-controls > input[type=checkbox]";
                        break;
                    case "folders":
                        inputSelector = "div.listing-container ul#categories div.wrapper:not(.parent-category) div.micro-controls > input[type=checkbox]";
                        break;
                    case "pages":
                        inputSelector = "div.listing-container ul#pages div.micro-controls > input[type=checkbox]";
                        break;
                    case "posts":
                        inputSelector = "div.listing-container ul#posts div.micro-controls > input[type=checkbox]";
                        break;
                    case "images":
                        inputSelector = "div.listing-container ul#files div.micro-controls > input[type=checkbox]";
                        break;
                    case "audio":
                        inputSelector = "div.listing-container ul#audio div.micro-controls > input[type=checkbox]";
                        break;
                    case "file":
                        inputSelector = "div.listing-container ul#file-attachments div.micro-controls > input[type=checkbox]";
                        break;
                }

                if (value == "nothing") {
                    _imageManager.find(inputSelector).removeAttr("checked");
                }
                else {
                    _imageManager.find(inputSelector).attr("checked", "checked");
                }

                _imageManager.find(inputSelector).trigger("change");


            });

            if ($.browser.msie) {
                _imageManager.find(".fileinput-button").removeClass("hide");
            } else {
                _imageManager.find("div.controls div.actions a.j-new-image").click(function (e) {
                    e.preventDefault();
                    _imageManager.find(".j-add-file").click();
                });
            }

            _imageManager.find("div.controls div.actions a.new-folder").click(function () {
                Cobalt.ImageManager.createFolder();
            });

            _imageManager.find("div.controls div.actions a.new-post").click(function () {
                self.location = "/cp/cms/posts/create?parentCategoryID=" + _entityID;
            });
            _imageManager.find("div.controls div.actions a.create-new-post").click(function (e) {
                self.location = "/cp/cms/posts/create?parentCategoryID=" + _entityID;
            });

            _imageManager.find("div.controls div.actions .create-new-post-from-template").click(function (e) {
                e.stopImmediatePropagation();
                self.location = "/cp/cms/posts/create?parentCategoryID=" + _entityID + "&post-type=3";
            });

            _imageManager.find("div.controls div.actions li.new-post").mouseover(function (e) {
                $(this).find(".post-menu").show();
            });

            _imageManager.find("div.controls div.actions li.new-post").mouseout(function (e) {
                $(this).find(".post-menu").hide();
            });

            _imageManager.find("div.controls div.actions a.new-page").click(function () {
                self.location = "/cp/cms/pages/create?parentCategoryID=" + _entityID;
            });

            _imageManager.find("div.controls div.actions a.edit-folder").click(function (evt) {
                Cobalt.ImageManager.editFolder(evt, _entityID);
            });

            _imageManager.find("div.controls div.actions a.new-video").click(function () {
                Cobalt.ImageManager.createVideo();
            });

            _searchFilter.keyup(function () {

                if ($(this).val() == "") {
                    $searchFilterReset.fadeOut();
                }
                else {
                    $searchFilterReset.fadeIn();
                }

                // Set a timer to auto-submit the form
                clearTimeout($autoSearchTimeout);
                $autoSearchTimeout = setTimeout(function () {
                    Cobalt.ImageManager.refreshListing();
                }, 500);

            });

            _searchFilter.parent().append($searchFilterReset);
            if (_searchFilter.val() != "") {
                _searchFilter.keyup();
            }

            // Initialize the jQuery File Upload widget:
            var $fileUpload = $('#image-manager').fileupload(
                {
                    autoUpload: true,
                    previewMaxWidth: _thumbnailWidth,
                    previewMaxHeight: _thumbnailHeight,
                    sequentialUploads: true,
                    timeout: 0
                }
            );

            var $fileUploaderInstance = $($fileUpload).data('fileupload');

            Cobalt.ImageManager.updateUploadAction();

            _viewControls = _imageManager.find("div.view > ul > li");
            _viewLinks = _viewControls.find("a");

            // Update the thumbnail size variables when the view links are clicked
            _viewLinks.each(function () {
                $(this).click(function () {
                    _sizeViewState.setValue($(this).attr("data-value"));
                    _thumbnailWidth = $(this).attr("data-thumbnail-width");
                    _thumbnailHeight = $(this).attr("data-thumbnail-height");
                    $fileUploaderInstance.options.previewMaxWidth = _thumbnailWidth;
                    $fileUploaderInstance.options.previewMaxHeight = _thumbnailHeight;
                    Cobalt.ImageManager.updateUploadAction();
                    return false;
                });
            });

            _sortControls = _imageManager.find("div.sort > ul > li");
            _sortLinks = _sortControls.find("a");

            // Update the sort view state
            _sortLinks.each(function () {
                $(this).click(function () {
                    _sortViewState.setValue($(this).attr("data-value"));
                    return false;
                });
            });

            Cobalt.runOnHtmlInsert(function () {
                $pagination.find("a").unbind("click");
                $pagination.find("a").click(function () {
                    var action = _listingFilterForm.attr("action");
                    var baseAction = action;

                    if (action.indexOf("?") > 0) {
                        baseAction = action.substring(0, action.indexOf("?"));
                    }

                    var linkQuery = $.query.load($(this).attr("href"));
                    if (linkQuery.get("page") == "") {
                        linkQuery = linkQuery.set("page", "1");
                    }

                    var newQuery = $.query.load(action);

                    for (var key in linkQuery.keys) {
                        newQuery = newQuery.set(key, linkQuery.keys[key]);
                    }

                    _listingFilterForm.attr("action", baseAction + newQuery.toString());
                    Cobalt.ImageManager.refreshListing();
                    return false;
                });
            }
            );



            if (_imageManagerModal.length > 0) {
                _imageManager.delegate("ul#files > li div.wrapper a", "click", function () {

                    // Get the attachment ID
                    var attachmentID = $(this).parents("li.attachment").attr("data-id");

                    // Get the thumbnail URL
                    $.ajax(
                        {
                            url: "/cp/cms/image-manager/attachment-url/" + attachmentID,
                            success: function (data) {
                                var thumb = data.thumbnailUrl;
                                var full = data.fullSizeUrl;

                                var selectedOption = $('input[name=image-insert-option]:checked').val();
                                if (selectedOption == null || selectedOption == "") {
                                    selectedOption = "thumb";
                                }
                                var html = "";
                                switch (selectedOption) {
                                    case "thumb":
                                        html = "<img src=\"" + thumb + "\">";
                                        break;
                                    case "lightbox":
                                        html = "<a class=\"lightbox\" href=\"" + full + "\"><img src=\"" + thumb + "\"></a>";
                                        break;
                                    case "full":
                                        html = "<img src=\"" + full + "\">";
                                        break;
                                }

                                _insertCallback(html);
                                Cobalt.ImageManager.hideModal();
                            }
                        }
                    );

                    return false;
                });

                Cobalt.runOnHtmlInsert(function (parent) {
                    parent.find("div.attachment-wrapper a").attr("title", "<div class=\"header\">Insert Image</div>Click here to insert this image at the default width (<b>" + _defaultImageWidth + " pixels</b>).<br><br>Note: You can set the default width in the Settings section of the News and Media Control Panel.").tooltip();
                });
            }
            else {
                Cobalt.runOnHtmlInsert(function () {
                    _imageManager.find("ul#files > li div.wrapper > a").addClass("lightbox");
                });
            }

            _listingFilterForm.addClass("ajax-listing");
            _listingFilterForm.attr("action", $formUrl);

            _listingFilterForm.ajaxForm({
                type: 'get',
                cache: false,
                beforeSubmit: function () {
                    if (_isLoading) {
                        return false;
                    }
                    _isLoading = true;
                    _loadingMask.fadeIn();
                },
                success: function (result) {

                    _loadingMask.hide();
                    _isLoading = false;
                    _hasLoaded = true;


                    // Thumbnail Size
                    _imageManager.attr("data-thumbnail-size", result.ThumbnailSize);

                    // Listing Results
                    var $newListing = $(result.Results);
                    $listing.replaceWith($newListing);
                    $listing = $newListing;


                    // Pagination
                    var $newPagination = $(result.Pagination);
                    if ($pagination.length == 0) {
                        _imageManager.find("div.listing-header").append($newPagination);
                        _imageManager.find("div.listing-footer").append($newPagination.clone());
                    }
                    else {
                        $pagination.each(function () {
                            $(this).replaceWith($newPagination.clone());
                        });
                    }

                    $pagination = _imageManager.find(".j-tablesorter-pager");

                    // Category Path
                    if (result.CategoryPath != null) {
                        var ul = $("<ul>").addClass("group");
                        for (var i = 0; i < result.CategoryPath.length; i++) {
                            var category = result.CategoryPath[i];
                            var li = $("<li>");
                            li.html(category.label);
                            li.attr("data-id", category.id);
                            ul.append(li);
                        }
                        _imageManager.find("div.folder-breadcrumbs > ul").replaceWith(ul);
                    }


                    // Display Mode                    
                    _imageManager.attr("data-display-mode", result.DisplayMode);

                    // Display Mode                    
                    _imageManager.attr("data-upload-mode", result.UploadMode);
                    _uploadMode = result.UploadMode;

                    $.info(_uploadMode);
                    if (_uploadMode == undefined || _uploadMode == 0) {
                        $(".image-manager-form").hide();
                    } else {
                        $(".image-manager-form").show();
                    }

                    _imageManager.attr("class", "");

                    // Parent ID
                    _currentParentID = result.ParentCategoryID;

                    // Return to Styling
                    var firstCategory = _imageManager.find("ul#categories > li:first-child > div");
                    if (firstCategory.attr("data-id") == _currentParentID) {
                        firstCategory.addClass("parent-category");
                    }

                    // Show instructions
                    Cobalt.ImageManager.showInstructions();

                    // Toggle Action Links
                    _allowedContentTypes = result.AllowedContentTypes;


                    _imageManager.find("div.actions li.contextual").hide();

                    for (var i = 0; i < _allowedContentTypes.length; i++) {
                        _imageManager.find("div.actions li.new-" + _allowedContentTypes[i]).css("display", "inline-block");
                    }

                    Cobalt.triggerHtmlInsert($listing);
                    Cobalt.triggerHtmlInsert($pagination);
                    Cobalt.ImageManager.updateUploadAction();
                    _imageManager.trigger("onLoadComplete");
                    return false;
                },
                error: function (result) {
                    _isLoading = false;
                    _loadingMask.hide();
                    return false;
                }
            });

            if (!_dragDropSupported) {
                $(".image-manager-form").show();
            }

            Cobalt.runOnHtmlInsert(function ($parent) {
                var displayModeField = $parent.find("#field-display-mode");
                displayModeField.change(function () {
                    if ($(this).val() == "4") {
                        $("#j-itunes-categories").show();
                        $("#j-syndication-itunes-notes").show();
                    }
                    else {
                        $("#j-itunes-categories").hide();
                        $("#j-syndication-itunes-notes").hide();
                    }
                });
                displayModeField.change();

                var includeListinAvatarField = $parent.find("#field-include-listing-avatar");
                includeListinAvatarField.change(function () {
                    if ($(this).val() == "t") {
                        $("#j-avatar-thumbnail-size").show();
                    }
                    else {
                        $("#j-avatar-thumbnail-size").hide();
                    }
                });
                includeListinAvatarField.change();

            });

            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find("div.wrapper > div.micro-controls > input[type=checkbox]").each(Cobalt.ImageManager.wireupCheckbox);
                $parent.find("div.wrapper > p.title").each(Cobalt.ImageManager.wireupTitles);
            });

            // Process view states

            _entityID = _categoryViewState.value;
            _thumbnailSize = _sizeViewState.value;
            _sortOrder = _sortViewState.value;

            Cobalt.ImageManager.refreshListing();

            $(window).bind('hashchange', function () {
                if (_hasLoaded) {
                    Cobalt.ViewStateManager.updateFromHash();
                    Cobalt.ImageManager.refreshListing();
                }
            });
        },
        handlePostClick: function (e) {
            if (_modeViewState.value === "template-select") {
                // Do specific stuff
                e.preventDefault();
                _insertCallback($(this).parent().attr("data-id"));
                _imageManagerModal.hide();
            }
        },
        createVideo: function () {
            try {
                _loadingMask.fadeIn();
                var url = "/cp/cms/videos/" + _entityID + "/create?width=" + _thumbnailWidth + "&height=" + _thumbnailHeight;
                $.ajax({
                    url: url,
                    success: function (data) {
                        Cobalt.ImageManager.createVideoModal(data.html, "New Video", "create");
                    },
                    dataType: "json"
                });

            } catch (e) { }
        },
        editVideo: function (evt, id, categoryID) {
            try {
                _loadingMask.fadeIn();
                var folder = $(this);
                var divWrapper = folder.parents("div.wrapper");
                id = id || divWrapper.attr("data-id");
                categoryID = categoryID || divWrapper.attr("data-category-id");
                var url = "/cp/cms/videos/" + categoryID + "/" + id + "/edit?width=" + _thumbnailWidth + "&height=" + _thumbnailHeight;
                $.ajax({
                    url: url,
                    success: function (data) {
                        Cobalt.ImageManager.createVideoModal(data.html, "Edit Video", "edit", id);
                    },
                    dataType: "json"
                });
            } catch (e) { }
        },
        createVideoModal: function (html, title, mode, id) {
            _loadingMask.hide();

            var $editDiv = $('<div>');
            $editDiv.html(html);
            mode = mode || "create";

            $editDiv.dialog({
                modal: true,
                dialogClass: "modal video-modal category-modal",
                draggable: false,
                title: title,
                resizable: false,
                close: function (event, ui) {
                    Cobalt.TinyMCE.unload();
                    $(event.target).dialog("destroy");
                    $(event.target).remove();
                }
            });

            $editDiv.find("button#field-cancel").click(function () {
                $editDiv.dialog("close");
                return false;
            });

            $editDiv.find("button#field-submit").click(function () {
                tinyMCE.triggerSave();
            });

            Cobalt.Tags.initialize();

            $editDiv.parent().center({ sizeToWindow: true, maxWidth: 640, maxHeight: 500 });

            var success = function (result) {
                $editDiv.dialog("close");
                _loadingMask.hide();
                if (result.Success) {
                    $.get("/cp/cms/videos/" + result.id + "/manager-item?width=" + _thumbnailWidth + "&height=" + _thumbnailHeight, function (data) {
                        var category = $(data);
                        var categoryList = _imageManager.find("ul#videos");
                        var existingCategory = categoryList.find('li[data-id="' + id + '"]');

                        setTimeout(function () {
                            if (existingCategory.length > 0) {
                                category.hide();
                                existingCategory.replaceWith(category);
                            }
                            else {
                                categoryList.prepend(category);
                            }
                            Cobalt.triggerHtmlInsert(category);
                            category = categoryList.find('li[data-id="' + id + '"]');
                            category.fadeIn(function () {
                                // Fix for IE7 and lower:
                                $(this).show();
                            });
                        }, 200);
                    });
                }
                else {
                    Cobalt.ImageManager.createVideoModal(result.html, title, mode, id);
                }
                return false;
            }

            $editDiv.find("form").ajaxForm(
                {
                    type: "post",
                    dataType: "json",
                    beforeSubmit: function () {
                        _loadingMask.fadeIn();
                    },
                    error: success,
                    success: success
                });
            Cobalt.triggerHtmlInsert($editDiv);
        },
        createFolder: function () {
            try {
                _loadingMask.fadeIn();
                var url = "/cp/cms/folders/" + _entityID + "/create";
                $.ajax({
                    url: url,
                    success: function (data) {
                        Cobalt.ImageManager.createFolderModal(data.html, "New Folder", "create");
                    },
                    dataType: "json"
                });

            } catch (e) { }
        },
        editFolder: function (evt, id) {

            try {
                _loadingMask.fadeIn();
                var folder = $(this);
                id = id || folder.parents("div.wrapper").attr("data-id");
                var url = "/cp/cms/folders/" + id + "/edit";
                $.get(url, function (data) {

                    Cobalt.ImageManager.createFolderModal(data.html, "Edit Folder", "edit", id);
                });
            } catch (e) { }
        },
        createFolderModal: function (html, title, mode, id) {

            _loadingMask.hide();

            var $editDiv = $('<div>');
            $editDiv.html(html);
            mode = mode || "create";

            $editDiv.dialog({
                modal: true,
                dialogClass: "modal category-modal",
                draggable: false,
                title: title,
                resizable: false,
                close: function (event, ui) {
                    $(event.target).dialog("destroy");
                    $(event.target).remove();
                }
            });

            $editDiv.find("button#field-cancel").click(function () {
                $editDiv.dialog("close");
                return false;
            });

            Cobalt.Tags.initialize();

            $editDiv.parent().center({ sizeToWindow: true, maxWidth: 800, maxHeight: 550, minHeight: 540 });
            $editDiv.find("form").ajaxForm(
                {
                    type: "post",
                    dataType: "json",
                    beforeSubmit: function () {
                        _loadingMask.fadeIn();
                    },
                    success: function (result) {
                        $editDiv.dialog("close");
                        _loadingMask.hide();
                        if (result.Success) {

                            var category = $.tmpl($("#category-template"), result);
                            var categoryList = _imageManager.find("ul#categories");
                            var parentCategory = categoryList.find('li > div[data-id="' + _currentParentID + '"]');
                            var existingCategory = null;

                            if (mode == "edit") {
                                existingCategory = categoryList.find('li > div[data-id="' + id + '"]').parent();
                                if (existingCategory.length == 0) {
                                    return;
                                }
                            }

                            if (parentCategory.length > 0) {
                                parentCategory = parentCategory.parent();
                            }

                            setTimeout(function () {

                                category.hide();

                                if (existingCategory != null && existingCategory.length > 0) {
                                    existingCategory.replaceWith(category);
                                    category = categoryList.find('li > div[data-id="' + id + '"]').parent();
                                }
                                else if (parentCategory.length > 0) {
                                    category.insertAfter(parentCategory);
                                }
                                else {
                                    categoryList.prepend(category);
                                }

                                category.fadeIn(function () {
                                    // Fix for IE7 and lower:
                                    $(this).show();
                                });
                            }, 200);
                        }
                        else {
                            Cobalt.ImageManager.createFolderModal(result.html, title, mode, id);
                        }
                        return false;
                    }
                });
            Cobalt.triggerHtmlInsert($editDiv);
        },
        editAudio: function (evt, id) {
            try {
                _loadingMask.fadeIn();
                var audio = $(this);
                id = id || audio.parents("li.audio").attr("data-id");
                var url = "/cp/cms/audio/" + id + "/edit";
                $.get(url, function (data) {
                    Cobalt.ImageManager.createAudioModal(data.html, "Edit Podcast", id);
                });
            } catch (e) { }
        },
        createAudioModal: function (html, title, id) {

            _loadingMask.hide();

            var $editDiv = $('<div>');
            $editDiv.html(html);

            $editDiv.dialog({
                modal: true,
                dialogClass: "modal category-modal",
                draggable: false,
                title: title,
                resizable: false,
                close: function (event, ui) {
                    $(event.target).dialog("destroy");
                    $(event.target).remove();
                }
            });

            $editDiv.find("button#field-cancel").click(function () {
                $editDiv.dialog("close");
                return false;
            });

            Cobalt.Tags.initialize();

            $editDiv.parent().center({ sizeToWindow: true, maxWidth: 540, maxHeight: 500, autoHeight: true, minHeight: 400 });

            var success = function (result) {
                $editDiv.dialog("close");
                _loadingMask.hide();
                if (result.Success) {
                    $.get("/cp/cms/audio/" + result.id + "/manager-item", function (data) {
                        var category = $(data);
                        var categoryList = _imageManager.find("ul#audio");
                        var existingCategory = categoryList.find('li[data-id="' + id + '"]');

                        setTimeout(function () {
                            category.hide();
                            existingCategory.replaceWith(category);
                            Cobalt.triggerHtmlInsert(category);
                            category = categoryList.find('li[data-id="' + id + '"]');
                            category.fadeIn(function () {
                                if (result.RecentlyPublished && confirm("This appears to be recently published audio. Would you like to create a Post for it?")) {
                                    self.location = "/cp/cms/posts/create?audio-id=" + id;
                                }
                                // Fix for IE7 and lower:
                                $(this).show();
                            });
                        }, 200);
                    });
                }
                else {
                    Cobalt.ImageManager.createAudioModal(result.html, title, id);
                }
                return false;
            }

            $editDiv.find("form").ajaxForm(
                {
                    type: "post",
                    dataType: "json",
                    beforeSubmit: function () {
                        _loadingMask.fadeIn();
                    },
                    error: success,
                    success: success
                });
            Cobalt.triggerHtmlInsert($editDiv);
        },
        handleFolderClick: function () {
            var $elem = $(this);

            if ($elem.is("img") || $elem.hasClass("modifier-icon")) {
                $elem = $elem.parent();
            }
            _searchFilter.val("");

            // Remove any page filters
            var action = _listingFilterForm.attr("action");
            if (action.indexOf("?") > 0) {
                var baseAction = action.substring(0, action.indexOf("?"));
                var linkQuery = $.query.load(action);
                if (linkQuery.get("page") != "") {
                    linkQuery = linkQuery.remove("page");
                }
                var newAction = baseAction + linkQuery.toString();
                _listingFilterForm.attr("action", newAction);
            }

            _entityID = $elem.attr("data-id");
            if (_categoryViewState != null && _categoryViewState.value == _entityID) {
                Cobalt.ImageManager.refreshListing();
            }
            else {
                _categoryViewState.setValue(_entityID);
            }

        },
        refreshListing: function () {
            var action = _listingFilterForm.attr("action");
            var baseAction = action;

            if (action != null && action.indexOf("?") > 0) {
                baseAction = action.substring(0, action.indexOf("?"));
            }

            var newQuery = $.query.load(action);

            _sortLinks.removeClass("active");
            _sortControls.find("a[data-value=" + _sortViewState.value + "]").addClass("active");

            _viewLinks.removeClass("active");
            _viewControls.find("a[data-value=" + _sizeViewState.value + "]").addClass("active");

            newQuery = newQuery.remove("filter-search");
            newQuery = newQuery.set("t", _sizeViewState.value);
            newQuery = newQuery.set("s", _sortViewState.value);
            newQuery = newQuery.set("entity-type-id", _entityTypeID);
            newQuery = newQuery.set("entity-id", _categoryViewState.value);
            newQuery = newQuery.set("post-type", _postTypeViewState.value);
            newQuery = newQuery.set("m", _modeViewState.value);
            newQuery = newQuery.set("f", _featuredViewState.value.toString());

            _bulkModerationForm.attr("action", Cobalt.Routes.Instance.CPCategoryContentBulkModeration(_categoryViewState.value));

            $('#page-container-content').animate({ scrollTop: 0 }, 0);
            _listingFilterForm.attr("action", baseAction + newQuery.toString());
            _listingFilterForm.submit();
        },
        wireupCheckbox: function () {

            var checkbox = $(this);

            if (checkbox.is(":checked")) {
                checkbox.parents("div.wrapper").addClass("selected");
            }

            checkbox.change(function () {
                var checkbox = $(this);
                if (checkbox.is(":checked")) {
                    checkbox.parents("div.wrapper").addClass("selected");
                }
                else {
                    checkbox.parents("div.wrapper").removeClass("selected");
                }
            });
        },
        updateUploadAction: function () {

            function S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            }
            function guid() {
                return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
            }

            $(".image-manager-form").attr("action",
                "/upload.ashx?thumbnail-width=" + _thumbnailWidth + "&thumbnail-height=" + _thumbnailHeight + "&entity-type-id=" + _entityTypeID + "&entity-id=" + _entityID + "&upload-mode=" + _uploadMode + "&guid=" + guid());
        },
        wireupTitles: function () {

            var title = $(this);

            title.click(function () {
                var title = $(this);
                var itemType = "attachment";
                var titleContainer = title.parents("li.attachment");
                if (titleContainer.length == 0) {
                    titleContainer = title.parents("li.audio");
                    itemType = "audio";
                }
                var attachmentID = titleContainer.attr("data-id");

                if (attachmentID) {

                    var renameUrl = itemType == "attachment" ? Cobalt.Routes.Instance.AttachmentRename(attachmentID) : Cobalt.Routes.Instance.AudioRename(attachmentID);
                    var titleText = title.text();

                    // Build up the form
                    var form = $("<form method=\"post\">").attr("action", renameUrl);
                    var renameTextBox = $("<input type=\"text\" name=\"title\">").attr("value", titleText);

                    //var cancelLink = $("<a>").text(L.Global.Buttons.Cancel());
                    form.append($(renameTextBox)).hide();

                    form.ajaxForm({
                        success: function (result) {
                            if (result.Status === undefined || (result.Status !== undefined && result.Status != "Invalid")) {
                                form.fadeOut(function () {
                                    var newTitle = form.find("input[name=title]").val();
                                    title.html(newTitle);
                                    form.remove();
                                    title.fadeIn();
                                });

                            }
                            else {
                                form.effect("shake", { times: 6 }, 30);
                            }
                        },
                        error: function () {

                        }
                    });


                    $(form).fadeIn(function () {
                        $(renameTextBox).focus();
                        $(renameTextBox).select();
                    });
                    title.hide();
                    title.before($(form));

                    titleContainer.unbind("click");
                    titleContainer.click(function (e) {
                        if ($(e.target).is("input")) {
                            return;
                        }
                        form.fadeOut(function () {
                            form.remove();
                            title.show();
                        });

                    });

                }
                return false;
            });
        }
    };

    // The UI version extends the basic fileupload widget and adds
    // a complete user interface based on the given upload/download
    // templates.
    $.widget('blueimpUI.fileupload', $.blueimp.fileupload, {
        getFileListing: function () {
            var imageManager = $("#image-manager");
            if (imageManager.length > 0) {
                switch (Cobalt.ImageManager.uploadMode()) {
                    case 1:
                        return imageManager.find("ul.listing-files");
                    case 2:
                        return imageManager.find("ul.listing-audio");
                    case 3:
                        return imageManager.find("ul.listing-file-attachments");
                }
            }
        },
        options: {
            // By default, files added to the widget are uploaded as soon
            // as the user clicks on the start buttons. To enable automatic
            // uploads, set the following option to true:
            autoUpload: false,
            // The following option limits the number of files that are
            // allowed to be uploaded using this widget:
            maxNumberOfFiles: undefined,
            // The maximum allowed file size:
            maxFileSize: undefined,
            // The minimum allowed file size:
            minFileSize: 1,
            // The regular expression for allowed file types, matches
            // against either file type or file name:
            acceptFileTypes: /.+$/i,
            // The regular expression to define for which files a preview
            // image is shown, matched against the file type:
            previewFileTypes: /^image\/(gif|jpeg|png)$/,
            // The maximum width of the preview images:
            previewMaxWidth: 80,
            // The maximum height of the preview images:
            previewMaxHeight: 80,
            // By default, preview images are displayed as canvas elements
            // if supported by the browser. Set the following option to false
            // to always display preview images as img elements:
            previewAsCanvas: true,
            // The file upload template that is given as first argument to the
            // jQuery.tmpl method to render the file uploads:
            uploadTemplate: function () {
                var imageManager = $("#image-manager");
                if (imageManager.length > 0) {
                    switch (Cobalt.ImageManager.uploadMode()) {
                        case 1:
                            return $('#image-template-upload');
                        case 2:
                            return $('#audio-template-upload');
                        case 3:
                            return $('#file-template-upload');
                    }
                }
            },
            // The expected data type of the upload response, sets the dataType
            // option of the $.ajax upload requests:
            dataType: 'json',

            drop: function (e, data) {
                if ($("#image-manager").length > 0) {
                    setTimeout(function () { $(".instructions").fadeOut(); }, 500);
                    if ($.cookie("Cobalt.ImageManager.instructions") == null) {
                        $.cookie("Cobalt.ImageManager.instructions", "1", { path: "/", expires: 365 });
                    }
                }
            },

            // The add callback is invoked as soon as files are added to the fileupload
            // widget (via file input selection, drag & drop or add API call).
            // See the basic file upload widget for more information:
            add: function (e, data) {

                Cobalt.ImageManager.updateUploadAction();

                if (_uploadMode == 0) {
                    return;
                }

                var noResults = $(this).find('.no-results');
                if (noResults.length > 0) {
                    noResults.remove();
                }

                var that = $(this).data('fileupload');
                that._adjustMaxNumberOfFiles(-data.files.length);
                data.isAdjusted = true;
                data.isValidated = that._validate(data.files);

                var parentContainer = that.getFileListing();

                data.context = that._renderUpload(data.files)
                    .prependTo(parentContainer).fadeIn(function () {
                        // Fix for IE7 and lower:
                        $(this).show();
                    }).data('data', data);

                if ((that.options.autoUpload || data.autoUpload) && data.isValidated) {
                    data.jqXHR = data.submit();
                }
            },
            // Callback for the start of each file upload request:
            send: function (e, data) {
                if (!data.isValidated) {
                    var that = $(this).data('fileupload');
                    if (!data.isAdjusted) {
                        that._adjustMaxNumberOfFiles(-data.files.length);
                    }
                    if (!that._validate(data.files)) {
                        return false;
                    }
                }
                if (data.context && data.dataType &&
                    data.dataType.substr(0, 6) === 'iframe') {
                    // Iframe Transport does not support progress events.
                    // In lack of an indeterminate progress bar, we set
                    // the progress to 100%, showing the full animated bar:
                    data.context.find('.ui-progressbar').progressbar(
                        'value',
                        parseInt(100, 10)
                    );
                }
            },
            // Callback for successful uploads:
            done: function (e, data) {
                var that = $(this).data('fileupload');
                if (!data.context) {
                    return;
                }
                data.context.each(function (index) {
                    var file = ($.isArray(data.result) && data.result[index]) || { error: 'emptyResult' };

                    if (file.error) {
                        that._adjustMaxNumberOfFiles(1);
                        $(this).fadeOut(function () {
                            that._renderUpload([file])
                                .css('display', 'none')
                                .replaceAll(this)
                                .fadeIn(function () {
                                    // Fix for IE7 and lower:
                                    $(this).show();
                                    var elem = $(this);
                                    setTimeout(function () {
                                        elem.fadeOut(function () {
                                            elem.remove();
                                        });
                                    }, 5000);
                                });
                        });
                        return;
                    }

                    $(this).fadeOut(function () {

                        var newElement = $(file.html);
                        newElement.css('display', 'none')
                            .replaceAll(this)
                            .fadeIn(function () {
                                // Fix for IE7 and lower:
                                $(this).show();
                                Cobalt.triggerHtmlInsert($(this));
                            });
                    });
                });

            },
            // Callback for failed (abort or error) uploads:
            fail: function (e, data) {
                var that = $(this).data('fileupload');
                that._adjustMaxNumberOfFiles(data.files.length);
                if (data.context) {
                    data.context.each(function (index) {
                        $(this).fadeOut(function () {
                            if (data.errorThrown !== 'abort') {
                                var file = data.files[index];
                                file.error = file.error || data.errorThrown
                                    || true;
                                that._renderDownload([file])
                                    .css('display', 'none')
                                    .replaceAll(this)
                                    .fadeIn(function () {
                                        // Fix for IE7 and lower:
                                        $(this).show();
                                    });
                            } else {
                                data.context.remove();
                            }
                        });
                    });
                } else if (data.errorThrown !== 'abort') {
                    that._adjustMaxNumberOfFiles(-data.files.length);
                    data.context = that._renderUpload(data.files)
                        .css('display', 'none')
                        .appendTo(this.getFileListing())
                        .fadeIn(function () {
                            // Fix for IE7 and lower:
                            $(this).show();
                        }).data('data', data);
                }
            },
            // Callback for upload progress events:
            progress: function (e, data) {
                if (data.context) {
                    data.context.find('.ui-progressbar').progressbar(
                        'value',
                        parseInt(data.loaded / data.total * 100, 10)
                    );
                }
            },
            // Callback for global upload progress events:
            progressall: function (e, data) {
                $(this).find('.overall-progressbar').progressbar('value', parseInt(data.loaded / data.total * 100, 10));
            },
            // Callback for uploads start, equivalent to the global ajaxStart event:
            start: function () {
                $(this).find('.overall-progressbar').progressbar('value', 0).fadeIn();
            },
            // Callback for uploads stop, equivalent to the global ajaxStop event:
            stop: function () {
                $(this).find('.overall-progressbar').fadeOut();
            },
            // Callback for file deletion:
            destroy: function (e, data) {
                var that = $(this).data('fileupload');
                if (data.url) {
                    $.ajax(data)
                        .success(function () {
                            that._adjustMaxNumberOfFiles(1);
                            $(this).fadeOut(function () {
                                $(this).remove();
                            });
                        });
                } else {
                    data.context.fadeOut(function () {
                        $(this).remove();
                    });
                }
            }
        },

        // Scales the given image (img HTML element)
        // using the given options.
        // Returns a canvas object if the canvas option is true
        // and the browser supports canvas, else the scaled image:
        _scaleImage: function (img, options) {
            options = options || {};
            var canvas = document.createElement('canvas'),
                scale = Math.min(
                    (options.maxWidth || img.width) / img.width,
                    (options.maxHeight || img.height) / img.height
                );
            if (scale >= 1) {
                scale = Math.max(
                    (options.minWidth || img.width) / img.width,
                    (options.minHeight || img.height) / img.height
                );
            }
            var actualWidth = parseInt(img.width * scale, 10);
            var actualHeight = parseInt(img.height * scale, 10);
            img.width = (actualWidth > options.maxWidth) ? options.maxWidth : actualWidth;
            img.height = (actualHeight > options.maxHeight) ? options.maxHeight : actualHeight;
            if (!options.canvas || !canvas.getContext) {
                return img;
            }
            canvas.width = img.width;
            canvas.height = img.height;
            canvas.getContext('2d')
                .drawImage(img, 0, 0, img.width, img.height);
            return canvas;
        },

        _createObjectURL: function (file) {
            var undef = 'undefined',
                urlAPI = (typeof window.createObjectURL !== undef && window) ||
                    (typeof URL !== undef && URL) ||
                    (typeof webkitURL !== undef && webkitURL);
            return urlAPI ? urlAPI.createObjectURL(file) : false;
        },

        _revokeObjectURL: function (url) {
            var undef = 'undefined',
                urlAPI = (typeof window.revokeObjectURL !== undef && window) ||
                    (typeof URL !== undef && URL) ||
                    (typeof webkitURL !== undef && webkitURL);
            return urlAPI ? urlAPI.revokeObjectURL(url) : false;
        },

        // Loads a given File object via FileReader interface,
        // invokes the callback with a data url:
        _loadFile: function (file, callback) {
            if (typeof FileReader !== 'undefined' &&
                FileReader.prototype.readAsDataURL) {
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    callback(e.target.result);
                };
                fileReader.readAsDataURL(file);
                return true;
            }
            return false;
        },

        // Loads an image for a given File object.
        // Invokes the callback with an img or optional canvas
        // element (if supported by the browser) as parameter:
        _loadImage: function (file, callback, options) {
            var that = this,
                url,
                img;
            if (!options || !options.fileTypes ||
                options.fileTypes.test(file.type)) {
                url = this._createObjectURL(file);
                img = $('<img>').bind('load', function () {
                    $(this).unbind('load');
                    that._revokeObjectURL(url);
                    callback(that._scaleImage(img[0], options));
                });
                if (url) {
                    img.prop('src', url);
                } else {
                    this._loadFile(file, function (url) {
                        img.prop('src', url);
                    });
                }
            }
        },

        // Link handler, that allows to download files
        // by drag & drop of the links to the desktop:
        _enableDragToDesktop: function () {
            var link = $(this),
                url = link.prop('href'),
                name = decodeURIComponent(url.split('/').pop())
                    .replace(/:/g, '-'),
                type = 'application/octet-stream';
            link.bind('dragstart', function (e) {
                try {
                    e.originalEvent.dataTransfer.setData(
                        'DownloadURL',
                        [type, name, url].join(':')
                    );
                } catch (err) { }
            });
        },

        _adjustMaxNumberOfFiles: function (operand) {
            if (typeof this.options.maxNumberOfFiles === 'number') {
                this.options.maxNumberOfFiles += operand;
                if (this.options.maxNumberOfFiles < 1) {
                    this._disableFileInputButton();
                } else {
                    this._enableFileInputButton();
                }
            }
        },

        _formatFileSize: function (file) {
            if (typeof file.size !== 'number') {
                return '';
            }
            if (file.size >= 1000000000) {
                return (file.size / 1000000000).toFixed(2) + ' GB';
            }
            if (file.size >= 1000000) {
                return (file.size / 1000000).toFixed(2) + ' MB';
            }
            return (file.size / 1000).toFixed(2) + ' KB';
        },

        _hasError: function (file) {
            if (file.error) {
                return file.error;
            }
            // The number of added files is subtracted from
            // maxNumberOfFiles before validation, so we check if
            // maxNumberOfFiles is below 0 (instead of below 1):
            if (this.options.maxNumberOfFiles < 0) {
                return 'maxNumberOfFiles';
            }
            // Files are accepted if either the file type or the file name
            // matches against the acceptFileTypes regular expression, as
            // only browsers with support for the File API report the type:
            if (!(this.options.acceptFileTypes.test(file.type) ||
                this.options.acceptFileTypes.test(file.name))) {
                return 'acceptFileTypes';
            }
            if (this.options.maxFileSize &&
                file.size > this.options.maxFileSize) {
                return 'maxFileSize';
            }
            if (typeof file.size === 'number' &&
                file.size < this.options.minFileSize) {
                return 'minFileSize';
            }
            return null;
        },

        _validate: function (files) {
            var that = this,
                valid;
            $.each(files, function (index, file) {
                file.error = that._hasError(file);
                valid = !file.error;
            });
            return valid;
        },

        _uploadTemplateHelper: function (file) {
            file.sizef = this._formatFileSize(file);
            return file;
        },

        _renderUploadTemplate: function (files) {
            var that = this;
            return $.tmpl(this.options.uploadTemplate(), $.map(files, function (file) {
                return that._uploadTemplateHelper(file);
            })
            );
        },

        _renderUpload: function (files) {

            var that = this, options = this.options, tmpl = this._renderUploadTemplate(files);

            if (!(tmpl instanceof $)) {
                return $();
            }
            tmpl.css('display', 'none');
            // .slice(1).remove().end().first() removes all but the first
            // element and selects only the first for the jQuery collection:
            tmpl.find('.progress div').slice(1).remove().end().first()
                .progressbar();
            tmpl.find('.start button').slice(
                this.options.autoUpload ? 0 : 1
            ).remove().end().first()
                .button({
                    text: false,
                    icons: { primary: 'ui-icon-circle-arrow-e' }
                });
            tmpl.find('.cancel button').slice(1).remove().end().first()
                .button({
                    text: false,
                    icons: { primary: 'ui-icon-cancel' }
                });
            tmpl.find('.preview').each(function (index, node) {
                that._loadImage(
                    files[index],
                    function (img) {
                        $(img).hide().appendTo(node).fadeIn();
                    },
                    {
                        maxWidth: options.previewMaxWidth,
                        maxHeight: options.previewMaxHeight,
                        fileTypes: options.previewFileTypes,
                        canvas: options.previewAsCanvas
                    }
                );
            });
            return tmpl;
        },

        _downloadTemplateHelper: function (file) {
            file.sizef = this._formatFileSize(file);
            return file;
        },

        _renderDownloadTemplate: function (files) {
            return;
        },

        _renderDownload: function (files) {
            return;
        },

        _startHandler: function (e) {
            e.preventDefault();
            var tmpl = $(this).closest('.template-upload'),
                data = tmpl.data('data');
            if (data && data.submit && !data.jqXHR) {
                data.jqXHR = data.submit();
                $(this).fadeOut();
            }
        },

        _cancelHandler: function (e) {
            e.preventDefault();
            var tmpl = $(this).closest('.template-upload'),
                data = tmpl.data('data') || {};
            if (!data.jqXHR) {
                data.errorThrown = 'abort';
                e.data.fileupload._trigger('fail', e, data);
            } else {
                data.jqXHR.abort();
            }
        },

        _deleteHandler: function (e) {
            e.preventDefault();
            var button = $(this);
            e.data.fileupload._trigger('destroy', e, {
                context: button.closest('.template-download'),
                url: button.attr('data-url'),
                type: button.attr('data-type'),
                dataType: e.data.fileupload.options.dataType
            });
        },

        _initEventHandlers: function () {
            $.blueimp.fileupload.prototype._initEventHandlers.call(this);
        },

        _destroyEventHandlers: function () {
            var filesList = this.getFileListing();
            if (filesList) {
                filesList.find('.start button')
                    .die('click.' + this.options.namespace);
                filesList.find('.cancel button')
                    .die('click.' + this.options.namespace);
                filesList.find('.delete button')
                    .die('click.' + this.options.namespace);
            }
            $.blueimp.fileupload.prototype._destroyEventHandlers.call(this);
        },

        _initFileUploadButtonBar: function () {
            var fileUploadButtonBar = this.element.find('.fileupload-buttonbar'),
                filesList = this.getFileListing(),
                ns = this.options.namespace;
            fileUploadButtonBar
                .addClass('ui-widget-header ui-corner-top');
            this.element.find('.fileinput-button').each(function () {
                var fileInput = $(this).find('input:file').detach();
                $(this).button({ icons: { primary: 'ui-icon-plusthick' } })
                    .append(fileInput);
            });
            if (filesList) {
                fileUploadButtonBar.find('.start')
                    .button({ icons: { primary: 'ui-icon-circle-arrow-e' } })
                    .bind('click.' + ns, function (e) {
                        e.preventDefault();
                        filesList.find('.start button').click();
                    });
                fileUploadButtonBar.find('.cancel')
                    .button({ icons: { primary: 'ui-icon-cancel' } })
                    .bind('click.' + ns, function (e) {
                        e.preventDefault();
                        filesList.find('.cancel button').click();
                    });
                fileUploadButtonBar.find('.delete')
                    .button({ icons: { primary: 'ui-icon-trash' } })
                    .bind('click.' + ns, function (e) {
                        e.preventDefault();
                        filesList.find('.delete button').click();
                    });
            }
        },

        _destroyFileUploadButtonBar: function () {
            this.element.find('.fileupload-buttonbar')
                .removeClass('ui-widget-header ui-corner-top');
            this.element.find('.fileinput-button').each(function () {
                var fileInput = $(this).find('input:file').detach();
                $(this).button('destroy')
                    .append(fileInput);
            });
            this.element.find('.fileupload-buttonbar button')
                .unbind('click.' + this.options.namespace)
                .button('destroy');
        },

        _enableFileInputButton: function () {
            this.element.find('.fileinput-button input:file:disabled')
                .each(function () {
                    var fileInput = $(this),
                        button = fileInput.parent();
                    fileInput.detach().prop('disabled', false);
                    button.button('enable').append(fileInput);
                });
        },

        _disableFileInputButton: function () {
            this.element.find('.fileinput-button input:file:enabled')
                .each(function () {
                    var fileInput = $(this),
                        button = fileInput.parent();
                    fileInput.detach().prop('disabled', true);
                    button.button('disable').append(fileInput);
                });
        },

        _initTemplates: function () {

        },

        _create: function () {
            $.blueimp.fileupload.prototype._create.call(this);
            this._initTemplates();

            this.element
                .addClass('ui-widget');
            this._initFileUploadButtonBar();
            this.element.find('.fileupload-content')
                .addClass('ui-widget-content ui-corner-bottom');
            this.element.find('.overall-progressbar')
                .hide().progressbar();
        },

        destroy: function () {
            this.element.find('.overall-progressbar')
                .progressbar('destroy');
            this.element.find('.fileupload-content')
                .removeClass('ui-widget-content ui-corner-bottom');
            this._destroyFileUploadButtonBar();
            this.element.removeClass('ui-widget');
            $.blueimp.fileupload.prototype.destroy.call(this);
        },

        enable: function () {
            $.blueimp.fileupload.prototype.enable.call(this);
            this.element.find(':ui-button').not('.fileinput-button')
                .button('enable');
            this._enableFileInputButton();
        },

        disable: function () {
            this.element.find(':ui-button').not('.fileinput-button')
                .button('disable');
            this._disableFileInputButton();
            $.blueimp.fileupload.prototype.disable.call(this);
        }

    });

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ImageManager.js